/**
 * Timeline Utilities
 *
 * Centralized constants and helpers for timeline entry management.
 * Auto-generated entries (Crew Call, Start Time, End Time) are managed
 * by the backend and should not be edited directly.
 */

/**
 * Reserved timeline labels that are auto-managed from event time fields.
 * These entries are created/updated automatically when event times change.
 */
export const RESERVED_LABELS = ['crew call', 'start time', 'end time'] as const;

/**
 * Check if a timeline entry label is reserved (case-insensitive).
 * Reserved labels cannot be used for manually-created timeline entries.
 */
export function isReservedLabel(label: string): boolean {
  return RESERVED_LABELS.includes(label.toLowerCase().trim() as typeof RESERVED_LABELS[number]);
}

/**
 * Check if a timeline entry is auto-generated based on its ID.
 * Auto-generated entries have IDs ending with specific suffixes.
 */
export function isAutoGeneratedEntry(entryId: string): boolean {
  return (
    entryId.endsWith('-crew-call') ||
    entryId.endsWith('-start-time') ||
    entryId.endsWith('-end-time')
  );
}

/**
 * Get display info for auto-generated entries
 */
export function getAutoGeneratedType(entryId: string): 'crew-call' | 'start-time' | 'end-time' | null {
  if (entryId.endsWith('-crew-call')) return 'crew-call';
  if (entryId.endsWith('-start-time')) return 'start-time';
  if (entryId.endsWith('-end-time')) return 'end-time';
  return null;
}
